import React, { Fragment } from 'react';

export const PopUpMessage = ({ messages }) => {
  return (
    <Fragment>
      {messages.MealType}
      <br />
      {messages.TotalParticipation}
      <br />
      {messages.ServingDate}
      <br />
      {messages.Site}
      <br />
      <br />
      <br />
      {messages.SiteStudents ? messages.SiteStudents : null}
    </Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/pages/cepbulkprocessing/components/PopUpMessage.js